import * as React from 'react';
import { IProductOrderTab } from '@applications/order-tracker/config/order-tracker-new-common/types';
import ProductDetails from './components/product-details';
import LocationAndContactDetails from './components/location-and-contact-details';
import EquipmentDetails from './components/equipment-details';
import AppointmentInformation from './components/appointment-information';
import ProductDetailsTabFooter from './components/product-details-tab-footer';
import { productAppointmentInformationBusinessRules, productEquipmentDetailsBusinessRules } from '@applications/order-tracker/config/order-tracker-new-common/order-products-utils';

const ProductDetailsTab = ({ product }: IProductOrderTab) => {
  const { showEquipmentDetailsSection } =
    productEquipmentDetailsBusinessRules(product.equipmentDetails);
  const { showAppointmentInformationSection } =
    productAppointmentInformationBusinessRules(product.appointmentDetails);

  return (
    <React.Fragment>
      <ProductDetails product={product} />
      <LocationAndContactDetails siteName={product.siteName}
        siteRawAddress={product.siteRawAddress}
        customerSiteContact={product.customerSiteContact}
        deliveryContact={product.deliveryContact}
        customerProjectContact={product.customerProjectContact} />
      {
        showEquipmentDetailsSection() && (
          <React.Fragment>
            <EquipmentDetails equipmentDetails={product.equipmentDetails} />
            {showAppointmentInformationSection() && <AppointmentInformation appointmentDetails={product.appointmentDetails} />}
          </React.Fragment>
        )
      }
      <ProductDetailsTabFooter />
    </React.Fragment>
  );
};

export default ProductDetailsTab;
